/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Grid } from '@mui/material'

import { 
  useGET_setupOptionsQuery,
  usePOST_setupOptionEnableMutation,
  usePOST_setupOptionDisableMutation 
} from 'redux/api/setupApi'

import { Form, Formik } from 'formik'
import CheckboxField from 'components/atoms/fields/CheckboxField'


const SyllabusSetupPolicyForm: FC = () => {
  const { t } = useTranslation()
  
  const policy1Options = [
    {key: 'syllabus_homework_policy', label: t('setup-syllabus-main.homework-policy')},
    {key: 'syllabus_tutorial_policy', label: t('setup-syllabus-main.tutorial-policy')},
    {key: 'syllabus_absentee_policy', label: t('setup-syllabus-main.absentee-policy')},
    {key: 'syllabus_tardy_policy', label: t('syllabuses.tardy-policy')},
    {key: 'syllabus_consequences', label: t('syllabuses.consequences')},
    {key: 'syllabus_late_work_procedures', label: t('setup-syllabus-main.late-work-procedures')},
    {key: 'syllabus_absence_procedures', label: t('setup-syllabus-main.absence-make-up-procedures')},
    {key: 'syllabus_extra_credits', label: t('setup-syllabus-main.extra-credits')}
  ]
 
  const policy2Options = [
    {key: 'syllabus_assignment_policy', label: t('setup-syllabus-main.assignment-policy')},
    {key: 'syllabus_turning_in_assignment', label: t('setup-syllabus-main.turning-in-assignment')},
    {key: 'syllabus_retake_policy', label: t('setup-syllabus-main.retake-policy')},
    {key: 'syllabus_assessment_type', label: t('setup-syllabus-main.type-of-assessment')},
    {key: 'syllabus_assessment_corrections', label: t('setup-syllabus-main.assessment-corrections')},
    {key: 'syllabus_grading_policy', label: t('setup-syllabus-main.grading-policy')},
    {key: 'syllabus_grading_breakdown', label: t('setup-syllabus-main.grading-breakdown')}
  ]

  const policy3Options = [
    {key: 'syllabus_behaviour_expectations', label: t('setup-syllabus-main.behaviour-expectation')},
    {key: 'syllabus_bullying_prevention', label: t('setup-syllabus-main.bullying-prevention')},
    {key: 'syllabus_student_responsibilities', label: t('setup-syllabus-main.student-responsibilities')},
    {key: 'syllabus_classroom_rules', label: t('setup-syllabus-main.classroom-rules')},
    {key: 'syllabus_plagiarism', label: t('setup-syllabus-main.plagiarism-academic-integrity')},
    {key: 'syllabus_penalties', label: t('setup-syllabus-main.penalties')}
  ]

  const { data: setupData } = useGET_setupOptionsQuery()
  const [enableOption, {isLoading: isEnableLoading, isSuccess: isEnableSuccess, error: enableError}] = usePOST_setupOptionEnableMutation()
  const [disableOption, {isLoading: isDisableLoading, isSuccess: isDisableSuccess, error: disableError}] = usePOST_setupOptionDisableMutation()

  const serverValues = setupData ?  {
    syllabus_course_policy : [{
      key: 'syllabus_course_policy',
      label: t('common.course-policy'),
      is_enabled: setupData.filter(s => s.slug == 'syllabus_course_policy' && s.is_enabled).length == 1
    }],
    policy1:
      policy1Options.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      }),
    policy2:
      policy2Options.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      }),
    policy3:
      policy3Options.map(o => {
        return {
          ...o,
          is_enabled: setupData.filter(s => s.slug == o.key && s.is_enabled).length == 1
        }
      })

  } : null


  return (

    <>{serverValues &&
    <Formik
      enableReinitialize
      initialValues={serverValues}
      onSubmit={(values) => {
      }}
    >
      {
        ({ values, setFieldValue, errors }) => 
        <Form>

          <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline' mb={2}>
              <Grid item xs={12} md={4} className="setup-section-title">
                <CheckboxField
                  isSwitch={true}
                  hasLine={true}
                  index={0}
                  valueSelector='is_enabled'
                  fieldProps={{
                    label: values.syllabus_course_policy[0].label,
                    name: `syllabus_course_policy[0]`
                  }} 
                  onChange={(value)=> {
                    if(value.is_enabled)enableOption(values.syllabus_course_policy[0].key)
                    else disableOption(values.syllabus_course_policy[0].key)
                  }}
                />
              </Grid>
          </Grid>


          {values.syllabus_course_policy[0].is_enabled &&
            <Grid rowSpacing={4} columnSpacing={4} container alignSelf='baseline' mb={2}>{
                [1,2,3].map(i =>
                  <Grid item xs={12} md={4} key={`policy-${i}`}>
                    {values[`policy${i}`].map((option,index) => 
                      <div key={index} style={{ marginBottom: '10px' }}>
                        <CheckboxField 
                          isSwitch={true}
                          hasLine={true}
                          index={index}
                          valueSelector='is_enabled'
                          fieldProps={{
                            label: option.label,
                            name: `policy${i}[${index}]`
                          }}
                          onChange={(value)=> {
                            if(value.is_enabled)enableOption(option.key)
                            else disableOption(option.key)
                          }}
                        />
                      </div>
                    )}
                  </Grid>
                )}
              </Grid>
          }
        </Form>
      }
    </Formik>
    }</>
  )
}
export default SyllabusSetupPolicyForm

